/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Profeature51Inputs */

const zh_plan_profeature51 = /** @type {(inputs: Plan_Profeature51Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打印功能`)
};

const en_plan_profeature51 = /** @type {(inputs: Plan_Profeature51Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Print feature`)
};

const es_plan_profeature51 = /** @type {(inputs: Plan_Profeature51Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Función de impresión`)
};

/**
* | output |
* | --- |
* | "Print feature" |
*
* @param {Plan_Profeature51Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_profeature51 = /** @type {((inputs?: Plan_Profeature51Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Profeature51Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_profeature51(inputs)
	if (locale === "en") return en_plan_profeature51(inputs)
	return es_plan_profeature51(inputs)
});
export { plan_profeature51 as "plan_proFeature5" }